/* eslint-disable no-console */
import mixpanel from "mixpanel-browser"

let isInitialized = false

export const ensureInitialized = () => {
  if (isInitialized) {
    return true
  }

  // If we're in the browser but not initialized, try to initialize
  if (typeof window !== "undefined") {
    initAnalytics()
    return isInitialized
  }

  return false
}

export const initAnalytics = (): boolean => {
  if (typeof window === "undefined" || isInitialized) {
    return isInitialized
  }

  // Initialize Mixpanel in development mode only if explicitly enabled
  const isDev = process.env.NODE_ENV === "development"
  const enableInDev = process.env.NEXT_PUBLIC_ENABLE_ANALYTICS_IN_DEV === "true"

  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN

  if (isDev && !enableInDev) {
    console.log("Analytics disabled in development mode")
    return false
  }

  if (!MIXPANEL_TOKEN) {
    console.log("Mixpanel token not found. Analytics will be disabled.")
    return false
  }

  try {
    mixpanel.init(MIXPANEL_TOKEN, {
      api_host: "https://api-eu.mixpanel.com",
      debug: isDev,
      track_pageview: true,
      loaded: (mixpanel) => {
        isInitialized = true
        // Identify the user if they are logged in
        const userId = localStorage.getItem("userId")
        if (userId) {
          mixpanel.identify(userId)
        }
      },
    })

    return true
  } catch (error) {
    console.error("Failed to initialize Mixpanel", error)
    return false
  }
}
